<template>
  <el-dialog
    title="提示"
    :visible.sync="isShow"
    width="480px"
    custom-class="lackBox"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <img class="topImg" :src="$utils.getPng('icon-gfans-lack')" />
    <fm-button
      class="rightBt"
      @click="handleClose"
      type="info"
      size="mini"
      text
      icon="icon-model-close"
    ></fm-button>
    <div class="dialog-body">
      <div class="font1">{{ lackInfo.title }}</div>
      <div class="font2" v-html="lackInfo.content"></div>
      <div class="btBox">
        <div class="feemooBt" @click="govip('/vip')">
          <span class="font4">{{ lackInfo.button }}</span>
        </div>
        <div class="font5" @click="govip('/welfare')" v-if="isBottom">
          {{ lackInfo.button_bottom }}
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'lackPointBox',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    isBottom: {
      type: Boolean,
      default: true,
    },
    lackInfo: {
      type: Object,
    },
  },
  data() {
    return {}
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    confirm() {
      this.$emit('confirm')
    },
    govip(url) {
      window.open(this.$glb.feemooUrl + url)
      setTimeout(() => {
        this.$emit('handleClose')
      }, 200)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .lackBox {
  width: 580px !important;
  .el-dialog__body {
    padding-top: 280px;
    padding-bottom: 32px;
    .topImg {
      width: 580px;
      height: 280px;
      position: absolute;
      right: 0;
      top: 0;
    }
    .rightBt {
      position: absolute;
      right: 20px;
      top: 20px;
      .svg-icon {
        color: #8a8b92 !important;
        &:hover,
        &:active {
          color: #2c2c2c !important;
        }
      }
      &:hover {
        background-color: #f6f6f6 !important;
      }
    }
    .dialog-body {
      padding-top: 24px;
      .font3 {
        color: #f67942 !important;
      }
      .btBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .feemooBt {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f67942;
          border-radius: 26px;
          width: 328px;
          height: 48px;
          cursor: pointer;
          &:hover {
            background: #ff9c71;
          }
          &:active {
            background: #d84f13;
          }
          .font4 {
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            line-height: 24px;
          }
        }
        .font5 {
          font-weight: 400;
          font-size: 14px;
          color: #f67942;
          line-height: 22px;
          cursor: pointer;
          margin-top: 8px;
        }
      }
    }
  }
}
.font1 {
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 8px;
  @include useTheme {
    color: getVar('text-color1-2c2c2c');
  }
}
.font2 {
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 20px;
  @include useTheme {
    color: getVar('text-color8-52565a');
  }
}
</style>
